<template>
  <div class="h-full relative">
    <div
      class="model-top top-3px z-100 h-69px bg-transparent flex-row font-bold text-28px w-full absolute flex item-center justify-center"
    >
      <span
        class="model-top-font absolute truncate top-10px z-999 max-w-1052px text-center text-white"
        >三维场景配置</span
      >
      <div class="h-full relative overflow-hidden w-[calc(50%-220px)]">
        <div
          class="top-left absolute h-full bg-no-repeat bg-auto w-[calc(100%+20px)] bg-right"
          :style="{ left: `${backgroundOffsetX * -1}px` }"
        ></div>
        <span class="anchor-pos text-white text-14px pl-5px absolute font-normal top-2px left-0">
          {{ `X:${anchorPos[0]} Y:${anchorPos[1]} Z:${anchorPos[2]}` }}
        </span>
      </div>
      <div class="top-mid h-full bg-no-repeat bg-auto w-700px text-center bg-center"></div>
      <div class="h-full relative overflow-hidden w-[calc(50%-220px)]">
        <div
          class="top-right absolute h-full bg-no-repeat bg-auto w-[calc(100%+20px)] bg-left"
          :style="{ right: `${backgroundOffsetX * -1}px` }"
        ></div>
      </div>
    </div>
    <div class="w-full h-full">
      <ModelView
        v-if="sceneDataLoad && isModifyAble"
        :sceneOptions="sceneOptions"
        @sendPlayer="sendPlayer"
        @loadModelEnd="loadModelEnd"
      >
      </ModelView>
      <div v-for="item in componentList" :key="item.id">
        <component
          v-if="item.show"
          :location="item.location"
          :is="item.component"
          :player="player"
          :loadModelStatus="loadModelStatus"
          :customProps="componentCustomProps"
          @componentEmit="handleComponentEmit"
          @closeComponent="closeComponent"
        ></component>
      </div>
      <div class="w-full absolute bottom-0 justify-center flex">
        <BasicTab
          v-if="allowOperate"
          class="absolute"
          :tags="basicTabList"
          :selectTagList="selectTagList"
          @tagsClick="tagsBasicClick"
        ></BasicTab>
      </div>
      <SetOriginPoint
        v-if="setOriginPointVisible"
        :player="player"
        :modifyOptions="sceneOptions"
        @close="setOriginPointClose"
        @setSucess="setOriginPointSuccess"
      ></SetOriginPoint>
    </div>
  </div>
</template>

<script>
import { ModelSceneApi } from '@wiz-api/scene-management'
import { tagsClick, removeTagsStatus } from '../assets/js/model/commonMethods'
import setModelVisible from '../assets/js/model/modelTree'
import exportComponents from '../assets/js/export/componentsList'

const modelSceneApi = new ModelSceneApi()

export default {
  name: 'SceneConfigure',
  components: {
    ...exportComponents,
  },
  data() {
    return {
      sceneOptions: {
        isEnableGis: false,
        latitude: 0,
        longitude: 0,
        name: '',
        id: '',
        folderId: '',
        jsonData: '',
      },
      wsApi: null,
      backgroundOffsetX: 0,
      anchorPos: [0, 0, 0],
      player: null,
      loadModelStatus: false,
      basicTabList: [
        {
          code: 'ModelTree',
          name: '模型树',
          maxHeight: '33rem',
          minHeight: '20rem',
          direction: 'left',
          icon: 'icon-yxr-modelTree',
        },
        {
          code: 'system.Pickup',
          name: '点选',
          icon: 'icon-yxr-clickSelect',
        },
        {
          name: '分割线',
          code: '',
          icon: 'icon-yxr-yc',
        },
        {
          name: '新增模型',
          code: 'AddModels',
          icon: 'icon-line-circleAdd',
          maxHeight: '35rem',
          minHeight: '30rem',
          direction: 'right',
        },
        {
          name: '环境动效',
          code: 'KineticEffect',
          icon: 'icon-bg-environment',
          maxHeight: '35rem',
          minHeight: '30rem',
          direction: 'right',
        },
        {
          name: '新增工程',
          code: 'AddEngineering',
          icon: 'icon-bg-tagGroup',
          maxHeight: '48rem',
          minHeight: '30rem',
          direction: 'right',
        },
        {
          name: '工程动画配置',
          code: 'EngineeringAnimationConfig',
          icon: 'icon-yxr-markList',
          maxHeight: '30rem',
          minHeight: '30rem',
          direction: 'right',
        },
        {
          name: '视角管理',
          code: 'ViewAngle',
          icon: 'icon-yxr-threeDimensionalMark',
          maxHeight: '35rem',
          minHeight: '30rem',
          direction: 'right',
        },
        {
          name: '组态管理',
          code: 'CompositeState',
          icon: 'icon-bg-application',
          maxHeight: '45rem',
          minHeight: '30rem',
          direction: 'right',
        },

        {
          name: '模型编辑工具',
          code: 'NodeEditTool',
          icon: 'icon-bg-tool',
          maxHeight: '19rem',
          minHeight: '19rem',
          direction: 'right',
        },
        {
          name: '场景动画',
          code: 'SceneAnimation',
          icon: 'icon-yxr-thirdPersonRoaming',
          maxHeight: '48rem',
          minHeight: '30rem',
          direction: 'right',
        },
        {
          name: '区域剖切',
          code: 'AreaClip',
          icon: 'icon-yxr-globalSection',
          maxHeight: '35rem',
          minHeight: '30rem',
          direction: 'right',
        },
      ],
      allowOperate: false,
      selectTagList: [],
      activeBasicList: [],
      componentList: [], // 当前激活的弹框列表
      activeBasic: '',
      modelTreeProp: {
        currentNodeItem: 0, // 当前激活的node
        currentNodeName: '', // 点选时当前激活的节点名称
        treeData: [], // 模型树数据
        defaultCheckedKey: [], // 模型树选中的节点
        filterItem: [], // 模型树不需要显示的节点及他的父节点列表
        modelHideList: [], // 模型隐藏队列
        modelTreeLoadEnd: false, // 模型树数据加载完毕
        spaceSwapStatus: false, // 交换空间状态
      },
      setOriginPointVisible: false,
      componentCustomProps: {},
      sceneDataLoad: false,
      isModifyAble: true,
    }
  },
  computed: {
    userInfo() {
      const userInfo = Wiz.AuthHooks.GetUserInfo()
      return userInfo?.profile || {}
    },
  },
  async created() {
    if (this.$route.query.sceneId) {
      const api = Wiz.GetApiClientInstance()?.basePath
      const apiSplitList = api.split('://')
      this.wsApi = new WebSocket(
        `${apiSplitList[0] === 'https' ? 'wss' : 'ws'}://${
          apiSplitList[1]
        }/api/scene-management/model-scene/modifying-model-scene?sceneId=${
          this.$route.query.sceneId
        }&userId=${this.userInfo.sub}&userName=${this.userInfo.name}`
      )
      this.wsApi.onopen = () => {}
      this.wsApi.onmessage = ({ data }) => {
        if (data) {
          const message = JSON.parse(data)
          if (!message.IsModifyAble) {
            this.$message.warning(message.ErronMsg)
            this.wsApi.close()
            this.wsApi = null
            this.isModifyAble = false
          }
        }
      }
      await this.getSceneDetail(this.$route.query.sceneId)
      this.sceneDataLoad = true
    }
  },
  mounted() {
    localforage.setItem('activeTagDetail', {
      rightComList: [], // 右侧弹框列表
      leftComList: [], // 左侧弹框列表
      activeTags: [], // 目前激活的功能列表
      basicTags: [], // 激活的基础功能
    })
    window.addEventListener('beforeunload', (e) => {
      localforage.removeItem('activeTagDetail')
    })
    const topTitleDom = document.querySelector('.model-top-font')
    this.backgroundOffsetX =
      // eslint-disable-next-line no-nested-ternary
      topTitleDom.offsetWidth - 700 > 0
        ? (topTitleDom.offsetWidth - 700) / 2 < 52
          ? (topTitleDom.offsetWidth - 700) / 2
          : 52
        : 0
  },
  beforeDestroy() {
    localforage.removeItem('activeTagDetail')
    this.wsApi.close()
    this.wsApi = null
  },
  methods: {
    // 处理组件事件
    handleComponentEmit(key, data) {
      this.$set(this.componentCustomProps, key, data)
    },
    // 关闭弹框组件
    async closeComponent(com) {
      const activeTagData = (await localforage.getItem('activeTagDetail')) || {}
      if (_.isEmpty(activeTagData) || !activeTagData.activeTags) {
        return
      }
      const removeTag = _.filter(activeTagData.activeTags, ['code', com])
      this.selectTagList = removeTagsStatus(removeTag, this.componentList)
    },
    // 获取场景详情
    async getSceneDetail(id) {
      const [err, res] = await modelSceneApi.get(id)
      if (!err) {
        this.sceneOptions = _.pick(res, [
          'isEnableGis',
          'latitude',
          'longitude',
          'name',
          'id',
          'folderId',
        ])
      }
      const [jsonErr, jsonRes] = await modelSceneApi.getModelSecenRelatedJson({ id })
      if (!jsonErr) {
        this.sceneOptions.jsonData = jsonRes
      }
      this.$set(this.componentCustomProps, 'sceneOptions', _.cloneDeep(this.sceneOptions))
    },
    // 激活基础功能
    async tagsBasicClick(code, tag) {
      this.selectTagList = (await tagsClick(tag, this.componentList, this.player)) || []
    },
    // player实例化完成
    sendPlayer(player) {
      this.player = player
      if (
        this.sceneOptions.isEnableGis &&
        (!this.sceneOptions.latitude || !this.sceneOptions.longitude)
      ) {
        this.setOriginPointVisible = true
      } else {
        this.allowOperate = true
      }
    },
    // 关闭gis设置
    setOriginPointClose() {
      this.setOriginPointVisible = false
    },
    // gis原点设置成功
    setOriginPointSuccess(data) {
      this.sceneOptions.longitude = data.longitude
      this.sceneOptions.latitude = data.latitude
      this.allowOperate = true
    },
    loadModelEnd() {
      this.loadModelStatus = true
    },
  },
}
</script>

<style lang="scss" scoped>
.model-top {
  .top-left {
    background-image: url('../assets/image/model/left.png');
  }

  .top-mid {
    background-image: url('../assets/image/model/mid.png');
  }

  .top-right {
    background-image: url('../assets/image/model/right.png');
  }
}
</style>
